// @ts-nocheck
export const COLOR_SCORE_PRESETS = { red: 45, yellow: 70, lightgreen: 85, green: 95 };
export const GRADING_COLORS = Object.keys(COLOR_SCORE_PRESETS);
export const COLOR_NAMES = { red: 'Red', yellow: 'Yellow', lightgreen: 'Light Green', green: 'Green' };
export const GRADING_PERCENTAGE_RANGES = { red: '0%-60%', yellow: '61%-79%', lightgreen: '80%-90%', green: '91%-100%' };
export const GRADING_STYLES = {
  red: { bg: 'var(--ae-status-not-yet)', label: 'Not Yet', text: '#12203a', description: 'The student does not yet demonstrate the skill.' },
  yellow: { bg: 'var(--ae-status-working)', label: 'Learning Zone', text: '#12203a', description: 'The student can demonstrate the skill with support.' },
  lightgreen: { bg: 'var(--ae-status-on-track)', label: 'On Track', text: '#12203a', description: 'The student can successfully demonstrate the skill at the current learning level.' },
  green: { bg: 'var(--ae-status-mastered)', label: 'Proficient', text: '#12203a', description: 'The student can successfully demonstrate and apply the skill independently.' },
  gray: { bg: 'var(--ae-status-na)', label: 'Not Assessed', text: '#12203a', description: 'This skill has not been assessed yet.' },
};

export function colorFromScore(value) {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const score = Number(value);
  if (!Number.isFinite(score)) return null;
  if (score <= 60) return 'red';
  if (score < 80) return 'yellow';
  if (score <= 90) return 'lightgreen';
  return 'green';
}

export function pointColor(point = {}) {
  return colorFromScore(point.score) || (GRADING_COLORS.includes(point.color) ? point.color : null);
}
